<template>
  <section
    ref="root"
    :class="{
      [$style['mdc-global-navigation']]: true,
      [$style['mdc-global-navigation--collapsed']]: provider.isCollapsed,
    }"
  >
    <div
      ref="menu"
      :class="{
        [$style['mdc-global-navigation__menu']]: true,
      }"
    >
      <nav ref="nav" :class="$style['mdc-global-navigation__nav']">
        <slot />
      </nav>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      provider: {
        isCollapsed: false,
      },
    };
  },
  provide() {
    return {
      globalNavigation: this.provider,
    };
  },
};
</script>

<style lang="scss" module>
@import "@mds/constants";
.mdc-global-navigation {
  position: relative;
  $width: 230px;
  @media print {
    display: none;
  }

  &__menu {
    position: sticky;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    z-index: $mds-z-index-modal-overlay - 1;
    height: 77vh;
  }

@media only screen and (min-height: 200px) and (max-height: 300px) {
  &__menu {
  height: 55vh;
}
}
@media only screen and (min-height: 301px) and (max-height: 350px) {
  &__menu {
  height:58vh;
}
}
@media only screen and (min-height: 351px) and (max-height: 390px) {
  &__menu {
  height: 60vh;
}
}
@media only screen and (min-height: 391px) and (max-height: 420px) {
  &__menu {
  height: 72vh;
}
}
@media only screen and (min-height: 421px) and (max-height: 520px) {
  &__menu {
  height: 74vh;
}
}
@media only screen and (min-height: 521px) and (max-height:650px) {
  &__menu {
  height: 82vh;
}
}
  &__header {
    position: fixed;
    margin-left: 0;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 0 $mds-space-2-x;
    z-index: $mds-z-index-modal-overlay;
  }

  &__nav {
    overflow-y: auto;
  }
  ::-webkit-scrollbar {
    height: 7px;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(171, 171, 171, 0.3);
    border-radius: 6px;
  }
}
</style>
